import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

interface DatetimeCellProps {
  row: any;
  column: any;
  dateFormat: string;
  timeFormat: string;
}
/**
 * PageSizeDropwdown
 *
 */
export const DatetimeCell = (props: Readonly<DatetimeCellProps>): JSX.Element => {
  const { row, column, dateFormat, timeFormat } = props;
  return (
    <React.Fragment>
      <FormattedDate value={row.values[column.id]} format={dateFormat}  />
      {' '}
      <FormattedTime value={row.values[column.id]} format={timeFormat}  />
    </React.Fragment>
  );
}
DatetimeCell.displayName = 'DatetimeCell';
